/* DESIGNSPOT – produktová stránka (facelift 10/2026)
   1) datum doručení u zboží skladem
   2) přepnutí výhod a slevy podle varianty
   3) galerie z mřížky fotek (počítač)
   4) sticky kratší sloupec
   5) lišta s tlačítkem na mobilu */
(function () {
  'use strict';
  var root = document.querySelector('.ds-pdp');
  if (!root) return;

  /* ---------- 1) datum doručení ---------- */
  function pragueToday() {
    try {
      var p = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Prague', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
      var a = p.split('-');
      return new Date(+a[0], +a[1] - 1, +a[2]);
    } catch (e) {
      var d = new Date();
      return new Date(d.getFullYear(), d.getMonth(), d.getDate());
    }
  }
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4,
      f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30,
      i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451),
      mo = Math.floor((h + l - 7 * m + 114) / 31), da = ((h + l - 7 * m + 114) % 31) + 1;
    return new Date(y, mo - 1, da);
  }
  var hCache = {};
  function holidays(y) {
    if (hCache[y]) return hCache[y];
    var s = {};
    ['1-1', '5-1', '5-8', '7-5', '7-6', '9-28', '10-28', '11-17', '12-24', '12-25', '12-26'].forEach(function (x) { s[x] = 1; });
    var e = easter(y);
    var gf = new Date(e); gf.setDate(e.getDate() - 2);
    var em = new Date(e); em.setDate(e.getDate() + 1);
    s[(gf.getMonth() + 1) + '-' + gf.getDate()] = 1;
    s[(em.getMonth() + 1) + '-' + em.getDate()] = 1;
    hCache[y] = s;
    return s;
  }
  function isBiz(d) {
    var w = d.getDay();
    if (w === 0 || w === 6) return false;
    return !holidays(d.getFullYear())[(d.getMonth() + 1) + '-' + d.getDate()];
  }
  function nextBiz(d) {
    var n = new Date(d);
    do { n.setDate(n.getDate() + 1); } while (!isBiz(n));
    return n;
  }
  function fmt(a, b) {
    if (a.getMonth() === b.getMonth()) return a.getDate() + '.\u00a0– ' + b.getDate() + '.\u00a0' + (b.getMonth() + 1) + '.';
    return a.getDate() + '.\u00a0' + (a.getMonth() + 1) + '.\u00a0– ' + b.getDate() + '.\u00a0' + (b.getMonth() + 1) + '.';
  }
  var ship = nextBiz(pragueToday());
  var d1 = nextBiz(ship);
  var d2 = nextBiz(d1);
  /* na Slovensko to někdy trvá o den déle */
  if ((document.documentElement.lang || '').slice(0, 2) === 'sk') d2 = nextBiz(d2);
  var dateText = 'u vás ' + fmt(d1, d2);
  root.querySelectorAll('[data-ds-date]').forEach(function (el) { el.textContent = dateText; });

  /* ---------- 2) varianty ---------- */
  function showVariant(v) {
    root.querySelectorAll('.ds-usp[data-variant-id]').forEach(function (el) {
      el.hidden = String(el.getAttribute('data-variant-id')) !== String(v.id);
    });
    var sale = root.querySelector('[data-ds-sale]');
    var pct = root.querySelector('[data-ds-pct]');
    if (sale && pct) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        pct.textContent = '– ' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + ' %';
        sale.hidden = false;
      } else {
        sale.hidden = true;
      }
    }
  }
  /* fotka varianty: v galerii je jen fotka vybrané varianty (data-ds-vslide), po přepnutí se vymění */
  var vImgId = null;
  function swapImg(img, tpl) {
    if (!img) return;
    img.removeAttribute('srcset');
    img.removeAttribute('src');
    img.setAttribute('data-src', tpl);
    img.classList.remove('lazyloaded');
    img.classList.add('lazyload');
    if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.unveil(img);
  }
  function showVariantImage(v) {
    var fi = v.featured_image;
    if (!fi || !fi.src || fi.id === vImgId) return;
    var slides = document.querySelectorAll('[data-ds-vslide]');
    if (!slides.length) return;
    vImgId = fi.id;
    var src = fi.src.replace(/^https?:/, '');
    var tpl = src.replace(/\.(jpe?g|png|webp|gif)(\?|$)/i, '_{width}x.$1$2');
    var zoom = src.replace(/\.(jpe?g|png|webp|gif)(\?|$)/i, '_1800x1800.$1$2');
    slides.forEach(function (s) {
      var img = s.querySelector('img');
      if (!img) return;
      if (img.hasAttribute('data-photoswipe-src')) {
        img.setAttribute('data-photoswipe-src', zoom);
        if (fi.width) img.setAttribute('data-photoswipe-width', fi.width);
        if (fi.height) img.setAttribute('data-photoswipe-height', fi.height);
      }
      if (fi.alt) img.setAttribute('alt', fi.alt);
      swapImg(img, tpl);
    });
    if (window.jQuery) {
      var $main = window.jQuery('[id^="ProductPhotos-"].slick-initialized');
      if ($main.length) $main.slick('slickGoTo', 0);
    }
  }
  var vsEl = document.querySelector('[data-ds-vimg]');
  if (vsEl) vImgId = +vsEl.getAttribute('data-ds-vimg');

  /* „Hodí se k tomu“: u každého druhu doplňku ukázat barvu podle vybrané varianty (jinak první dostupnou) */
  var COL = { 'bílá': 'white', 'biela': 'white', 'béžová': 'beige', 'černá': 'black', 'čierna': 'black',
    'tmavě hnědá': 'dark brown', 'tmavohnedá': 'dark brown', 'hnědá': 'dark brown', 'hnedá': 'dark brown',
    'šedá': 'grey', 'sivá': 'grey', 'nerez': 'stainless steel', 'ořech': 'walnut', 'orech': 'walnut', 'dub': 'oak', 'jasan': 'ash' };
  function pickUps(v) {
    var box = root.querySelector('[data-ds-ups]');
    if (!box) return;
    var want = [];
    ((v && v.options) || []).forEach(function (o) {
      String(o).toLowerCase().split('/').forEach(function (x) { x = x.trim(); want.push(COL[x] || x); });
    });
    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-ds-ugrp]'));
    var groups = [];
    rows.forEach(function (r) { var g = r.getAttribute('data-ds-ugrp'); if (groups.indexOf(g) < 0) groups.push(g); });
    var last = null;
    groups.forEach(function (g) {
      var gr = rows.filter(function (r) { return r.getAttribute('data-ds-ugrp') === g; });
      var pick = null;
      for (var i = 0; i < want.length && !pick; i++) {
        pick = gr.filter(function (r) { return r.getAttribute('data-ds-ucol') === want[i]; })[0] || null;
      }
      pick = pick || gr[0];
      gr.forEach(function (r) { r.hidden = r !== pick; r.classList.remove('is-last'); });
      last = pick;
    });
    if (last) last.classList.add('is-last');
  }
  var dsPj = root.querySelector('[id^="VariantsJson-"]');
  var dsIdEl = root.querySelector('form.product-single__form [name="id"]');
  try {
    var dsVs = dsPj ? JSON.parse(dsPj.textContent) : [];
    var dsVid = dsIdEl ? String(dsIdEl.value) : '';
    var dsV = dsVs.filter(function (x) { return String(x.id) === dsVid; })[0] || dsVs.filter(function (x) { return x.available; })[0] || dsVs[0];
    pickUps(dsV);
  } catch (e) { pickUps(null); }

  if (window.jQuery) {
    window.jQuery(document).on('variantChange', function (e) {
      if (!e || !e.variant) return;
      showVariant(e.variant);
      showVariantImage(e.variant);
      pickUps(e.variant);
    });
  }

  /* ---------- 3) galerie ---------- */
  function openGallery(idx) {
    if (!window.PhotoSwipe || !window.PhotoSwipeUI_Default) return;
    var pswp = document.querySelector('.pswp');
    if (!pswp) return;
    var items = [], start = 0, seen = {};
    root.querySelectorAll('.product__main-photos img[data-photoswipe-src]').forEach(function (im) {
      if (im.closest('.slick-cloned')) return;
      var di = +im.getAttribute('data-index') - 1;
      if (seen[di]) return;
      seen[di] = 1;
      if (di === idx) start = items.length;
      items.push({
        src: im.getAttribute('data-photoswipe-src'),
        w: +im.getAttribute('data-photoswipe-width') || 1800,
        h: +im.getAttribute('data-photoswipe-height') || 1800
      });
    });
    if (!items.length) return;
    var g = new window.PhotoSwipe(pswp, window.PhotoSwipeUI_Default, items, {
      index: start, history: false, allowPanToNext: false, captionEl: false, closeOnScroll: false,
      counterEl: false, pinchToClose: false, preloaderEl: false, shareEl: false, tapToToggleControls: false
    });
    g.init();
  }
  root.querySelectorAll('[data-ds-index]').forEach(function (btn) {
    btn.addEventListener('click', function () { openGallery(+btn.getAttribute('data-ds-index')); });
  });

  /* ---------- 4) sticky: přichytí se kratší ze dvou sloupců (fotky / informace) ---------- */
  var media = root.querySelector('.ds-pdp__media');
  var info = root.querySelector('.ds-pdp__info');
  function setTop() {
    if (!media || !info) return;
    media.classList.remove('is-sticky');
    info.classList.remove('is-sticky');
    if (window.innerWidth <= 768) return;
    var shorter = media.offsetHeight < info.offsetHeight ? media : info;
    var top = Math.min(110, window.innerHeight - shorter.offsetHeight - 24);
    shorter.style.setProperty('--ds-top', top + 'px');
    shorter.classList.add('is-sticky');
  }
  setTop();
  /* najížděcí animace bloků pod produktem: po dorovnání výšky stránky přepočítat jejich pozice */
  var aosT;
  function aosRefresh() {
    clearTimeout(aosT);
    aosT = setTimeout(function () { if (window.AOS && window.AOS.refresh) window.AOS.refresh(); }, 200);
  }
  window.addEventListener('load', aosRefresh);
  document.addEventListener('lazyloaded', aosRefresh);
  if (window.jQuery) window.jQuery(document).on('init', '.slick-slider', aosRefresh);
  window.addEventListener('resize', setTop);
  window.addEventListener('load', setTop);
  document.addEventListener('lazyloaded', function () { setTimeout(setTop, 50); });
  document.querySelectorAll('.collapsible-trigger').forEach(function (b) { b.addEventListener('click', function () { setTimeout(setTop, 400); }); });

  /* ---------- 6) pole s počtem kusů: nepouštět do něj fokus bez ťuknutí uživatele
     (na iPhonu se po načtení stránky samo otevíralo s klávesnicí) ---------- */
  var lastTouch = null, lastTouchAt = 0, tabKey = false;
  document.addEventListener('pointerdown', function (e) { lastTouch = e.target; lastTouchAt = Date.now(); }, true);
  document.addEventListener('touchstart', function (e) { lastTouch = e.target; lastTouchAt = Date.now(); }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab') tabKey = true; }, true);
  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el.classList || !el.classList.contains('js-qty__num')) return;
    var touched = lastTouch && Date.now() - lastTouchAt < 1500 && el.closest('.js-qty__wrapper').contains(lastTouch);
    if (!touched && !tabKey) el.blur();
  }, true);

  /* ---------- 5) lišta s tlačítkem (mobil) ---------- */
  /* lišta je zatím vypnutá (rozhodnutí 28. 10. 2026) – zapnout přepnutím DS_BAR na true */
  var DS_BAR = false;
  var form = root.querySelector('form.product-single__form');
  var main = form && form.querySelector('[name="add"]');
  if (DS_BAR && form && main) {
    var bar = document.createElement('div');
    bar.className = 'ds-bar';
    bar.innerHTML = '<div class="ds-bar__row"><div class="ds-bar__n"><span class="ds-bar__v"></span><span class="ds-bar__name"></span></div><div class="ds-bar__p"><b></b><s></s></div></div><button type="button" class="btn btn--no-animate ds-bar__btn"></button>';
    document.body.appendChild(bar);
    var bb = bar.querySelector('button');
    var vEl = root.querySelector('.product-single__vendor');
    var tEl = root.querySelector('.product-single__title');
    bar.querySelector('.ds-bar__v').textContent = vEl ? vEl.textContent.trim() : '';
    bar.querySelector('.ds-bar__name').textContent = tEl ? tEl.textContent.trim() : '';
    var fill = function () {
      var p = root.querySelector('[id^="ProductPrice-"]');
      var c = root.querySelector('[id^="ComparePrice-"]');
      var ct = c && c.offsetParent !== null ? c.textContent.trim() : '';
      var b = bar.querySelector('.ds-bar__p b');
      b.textContent = p ? p.textContent.trim() : '';
      b.classList.toggle('is-sale', !!ct);
      bar.querySelector('.ds-bar__p s').textContent = ct;
      bb.textContent = (main.textContent || '').trim();
    };
    bb.addEventListener('click', function () {
      if (main.disabled) return;
      if (form.requestSubmit) form.requestSubmit(main); else main.click();
    });
    var onScroll = function () {
      var r = main.getBoundingClientRect();
      var on = window.innerWidth <= 768 && r.bottom < 0 && !main.disabled;
      if (on) fill();
      bar.classList.toggle('is-on', on);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
})();
